import cancellablePromiseProxy from '@aspectus/cancellable-promise-proxy'
import { useLoadable } from '@/packages/vue-loading-state'
import type { BaseResource } from '@/plugins/resource'


export function useCancelableRequest<T>(
  resource: BaseResource,
  transform: (data: any) => T = (data) => data
) {

  function request(...args) {
    const cancelController = new AbortController()
    const _resource = resource.config(
      'signal',
      cancelController.signal
    )
    const _request = cancellablePromiseProxy(
      new Promise((resolve, reject) => {
        _resource.execute(...args).then(resolve, reject)
      }),
      { cancelController }
    )
      .then((data ) => {
        return transform(data || null)
      })
      .catch((err) => (err.name == 'AbortError' ? [] : err))
    return _request
  }
  const { load, lastPromise, loading, result } = useLoadable(request)

  return { load, lastPromise, loading, result, request }
}


export default {}